module.exports = __webpack_public_path__ + "static/media/vovlo_logo.795c924d.png";